import React from 'react';
import {motion} from 'framer-motion';

const WhoWeHelp=()=> {
  const providers=[
    {
      name: "Verizon Business",
      description: "Reduce your Verizon FiOS and NYC business internet service costs below the average internet bill NYC businesses pay",
      color: "from-red-600 to-red-800"
    },
    {
      name: "Spectrum Business", 
      description: "Lower your Charter Spectrum Manhattan business internet bill through expert negotiation strategies",
      color: "from-blue-600 to-blue-800"
    },
    {
      name: "Comcast Business",
      description: "Cut your Xfinity NYC business internet service expenses with our proven negotiation approach",
      color: "from-purple-600 to-purple-800"
    },
    {
      name: "Optimum Business",
      description: "Reduce Optimum business costs and learn how to negotiate internet bill terms for better rates",
      color: "from-green-600 to-green-800"
    },
    {
      name: "Stealth Communications",
      description: "Lower your Stealth fiber Manhattan business internet bills through professional consultation",
      color: "from-indigo-600 to-indigo-800"
    },
    {
      name: "Pilot Fiber",
      description: "Reduce your Pilot fiber NYC business internet costs with our lower internet bill consultation service",
      color: "from-teal-600 to-teal-800"
    }
  ];

  const businessTypes=[
    "Small & Medium NYC Businesses",
    "Manhattan Restaurants & Retail", 
    "NYC Medical & Dental Offices",
    "Law Firms & Professional Services",
    "Manufacturing & Warehouses",
    "Manhattan Real Estate Offices"
  ];

  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{opacity: 0,y: 50}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-white mb-4">NYC Business Internet Services We Help Optimize</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            We work with businesses across NYC and Hudson Valley to reduce costs with all major internet providers. 
            Our Manhattan business internet specialists help you pay less than the average internet bill NYC businesses typically face.
          </p>
        </motion.div>

        {/* Internet Providers */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-white mb-8 text-center">NYC Business Internet Service Providers We Negotiate With</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {providers.map((provider,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,scale: 0.9}}
                whileInView={{opacity: 1,scale: 1}}
                transition={{duration: 0.8,delay: index * 0.1}}
                className="bg-gray-800 p-6 rounded-xl border border-gray-700 hover:border-red-500 transition-all duration-300"
              >
                <h3 className="text-xl font-semibold text-white mb-2">{provider.name}</h3>
                <p className="text-gray-400">{provider.description}</p>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Business Types */}
        <div>
          <h3 className="text-2xl font-bold text-white mb-8 text-center">NYC Business Types We Serve</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {businessTypes.map((type,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,x: -50}}
                whileInView={{opacity: 1,x: 0}}
                transition={{duration: 0.8,delay: index * 0.1}}
                className="bg-gradient-to-r from-red-600 to-blue-600 text-white p-4 rounded-lg text-center font-semibold"
              >
                {type}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeHelp;